export default __webpack_public_path__ + "static/media/img62.2a3259e8.jpg";